document.addEventListener('DOMContentLoaded', function () {
  const heroSectionDesk = document.querySelector('#shopify-section-template--17276878127243__image_banner_WFAWH8');
  const heroSectionMob = document.querySelector('#shopify-section-template--17276878127243__image_banner_MbtGjc');

  const logo = document.querySelector('.header__heading-link');
  const menu = document.querySelector('.header__inline-menu');

  // Define thresholds for desktop and mobile
  const desktopThreshold = 0.888;
  const mobileThreshold = 0.438;

  // Determine if the device is mobile based on screen width
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const threshold = isMobile ? mobileThreshold : desktopThreshold;

  const observerOptions = {
    root: null, // Use the viewport as the root
    threshold: threshold
  };

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Hero section is in view; hide the logo
        // logo.classList.add('logo-hidden');
        // menu.style.setProperty('grid-area', 'heading', 'important');
      } else {
        // Hero section is out of view; show the logo
        logo.classList.remove('logo-hidden');
        menu.style.setProperty('grid-area', 'navigation', 'important');
      }
    });
  };

  // Following is the logic for hiding and unhiding logo on scroll past header
  const observer = new IntersectionObserver(observerCallback, observerOptions);

  if (heroSectionDesk) observer.observe(heroSectionDesk);
  if (heroSectionMob) observer.observe(heroSectionMob);
});
